import { benefits, stats } from '@/mocks/home';

export default function Benefits() {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            为什么选择开云体育
          </h2>
          <p className="mt-2 text-sm text-foreground-500">五大核心优势，打造极致体育娱乐体验</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 mb-14">
          {benefits.map((item) => (
            <div
              key={item.id}
              className="bg-background-50 border border-background-200/80 rounded-lg p-6 hover:-translate-y-1 transition-all duration-300"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 mb-4">
                <i className={`${item.icon} text-2xl`}></i>
              </div>
              <h3 className="text-base font-semibold text-foreground-800 mb-2">{item.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center p-4">
              <div className="text-2xl md:text-3xl font-heading font-bold text-primary-500 mb-1">
                {stat.value}
              </div>
              <div className="text-xs md:text-sm text-foreground-500">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}